import { useTranslation } from 'react-i18next';
import { TextEditor } from '@/features/TextEditor';
import { TFormBuilderTextField } from '@/types';

type TProps = {
  field: TFormBuilderTextField;
};

/**
 * Preview component for text field in form builder
 * @param props - Component props
 * @param props.field - Text field data to preview
 * @returns Form builder text preview component
 */
export const FormBuilderPreviewText = ({ field }: TProps) => {
  const { t } = useTranslation();

  return (
    <TextEditor
      value={field.text}
      disabled
      aria-label={t('form-builder.text')}
    />
  );
};
